<template>
    <div :class="['page-state', { 'page-state--inline': inline }]" role="status" aria-live="polite">
        <div class="page-state__icon" aria-hidden="true">
            <v-progress-circular v-if="loading" indeterminate color="secondary" size="26" />
            <v-icon v-else size="28" color="secondary">{{
                error ? 'mdi-cloud-alert' : icon
            }}</v-icon>
        </div>
        <div class="page-state__content">
            <h2>
                {{
                    loading ? 'Carregando informações' : error ? 'Não foi possível carregar' : title
                }}
            </h2>
            <p>
                {{
                    loading
                        ? 'Aguarde um instante.'
                        : error
                        ? 'Tente novamente em alguns instantes.'
                        : description
                }}
            </p>
            <v-btn v-if="error" outlined color="primary" class="pbb-btn" @click="$emit('retry')"
                >Tentar novamente</v-btn
            >
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    name: 'PageState',
    props: {
        loading: Boolean,
        error: Boolean,
        inline: Boolean,
        title: { type: String, default: 'Nenhum resultado encontrado' },
        description: { type: String, default: 'Tente buscar por outro termo.' },
        icon: { type: String, default: 'mdi-magnify' }
    }
};
</script>
